var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlmNavigationImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4562 26.25L17.5 23.0563L24.5437 26.25L25.2 25.5938L17.5 7L9.8 25.5938L10.4562 26.25ZM17.5 35C15.0792 35 12.8042 34.5403 10.675 33.621C8.54583 32.7028 6.69375 31.4563 5.11875 29.8813C3.54375 28.3063 2.29717 26.4542 1.379 24.325C0.459667 22.1958 0 19.9208 0 17.5C0 15.0792 0.459667 12.8042 1.379 10.675C2.29717 8.54583 3.54375 6.69375 5.11875 5.11875C6.69375 3.54375 8.54583 2.29658 10.675 1.37725C12.8042 0.459083 15.0792 0 17.5 0C19.9208 0 22.1958 0.459083 24.325 1.37725C26.4542 2.29658 28.3063 3.54375 29.8813 5.11875C31.4563 6.69375 32.7028 8.54583 33.621 10.675C34.5403 12.8042 35 15.0792 35 17.5C35 19.9208 34.5403 22.1958 33.621 24.325C32.7028 26.4542 31.4563 28.3063 29.8813 29.8813C28.3063 31.4563 26.4542 32.7028 24.325 33.621C22.1958 34.5403 19.9208 35 17.5 35Z",
    fill: "url(#paint0_linear_364_2613)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_364_2613",
    x1: 17.5,
    y1: 0,
    x2: 17.5,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#387FF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF61CB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlmNavigationImage);
export default __webpack_public_path__ + "static/media/plm_Navigation_image.a083640dcbc937c9322cceb4aa207b2e.svg";
export { ForwardRef as ReactComponent };